import { STEPS } from '../components/quote/wizardTypes'
import { pixelEsemeny } from './metaPixel'
import { attribucio } from './attribution'

/**
 * KONVERZIOMERES.
 *
 * ────────────────────────────────────────────────────────────────────
 * SZEMELYES ADAT IDE NEM KERUL.
 *
 * Sem e-mail, sem telefonszam, sem cim, sem modellfajlnev, sem a modell
 * tartalma. A vedelem KETSZERES: itt csak a felsorolt mezoket kuldjuk el,
 * a szerveroldali `analytics_track` fuggveny pedig ujra kiszuri a tiltott
 * kulcsokat. Igy egy elirt kliensoldali hivas sem tud kiszivárogtatni
 * semmit - a vedelem nem a mi jomodorusagunkon mulik.
 * ────────────────────────────────────────────────────────────────────
 *
 * ────────────────────────────────────────────────────────────────────
 * A MUNKAMENET-AZONOSITO TULELI AZ OLDALFRISSITEST
 *
 * Korabban ez az azonosito csak a dokumentum JavaScript-memoriajaban
 * elt, es minden F5-re ujra keletkezett. A tolcser viszont
 * `count(distinct session_id)`-vel szamol (`v_funnel`), ezert UGYANAZ a
 * latogato annyi "latogatokent" jelent meg, ahanyszor frissitett -
 * es minden lepes aranya ehhez a felfujt szamhoz mérodott. A mert
 * konverzio igy nem csak pontatlan volt, hanem RENDSZERESEN alabecsult.
 *
 * Ezert az azonosito a `localStorage`-ba kerul. Ez a vegberendezesen
 * tortenő adattarolas, tehat jogilag is szamit - a tajekoztatas a
 * `/sutik` es az `/adatkezeles` oldalon ennek megfeleloen valtozott.
 *
 * ────────────────────────────────────────────────────────────────────
 * MIERT LATOGATASHOZ KOTOTT ES NEM SZEMELYHEZ
 *
 * Kezenfekvo lenne egy allando "latogato-azonositot" tarolni, amivel a
 * visszatero ember is felismerheto. NEM ezt csinaljuk:
 *
 *   - a kerdes, amire valaszolni akarunk, egy LATOGATASROL szol
 *     ("aki elkezdte, eljutott-e a vegeig"), nem egy emberrol,
 *   - egy honapokig eloő azonosito mar szemelykovetes, amihez sokkal
 *     erosebb jogalap kell - a merestol viszont semmivel nem lenne tobb.
 *
 * A token ezert KETSZERESEN korlatos: fel ora tetlenseg utan uj
 * latogatas kezdodik, es tizenket ora utan mindenkeppen. Ennel tovabb
 * egyetlen azonosito sem el.
 * ────────────────────────────────────────────────────────────────────
 */

export type AnalyticsEvent =
  | 'page_view'
  | 'calculator_opened'
  /*
    ────────────────────────────────────────────────────────────────
    A FELTOLTES NEGY UJ MEROPONTJA - MIERT KELLETT

    A 2026-08-21-i kampanynapon a mert tolcser ez volt:

      calculator_opened  130
      file_validated      33
      estimate_shown       3
      quote_submitted      0

    A 130 es a 33 kozott 97 latogato veszett el, es errol a szakaszrol
    NEM VOLT ADAT. Nem lehetett megkulonboztetni azt, aki ra sem nyult a
    feltoltore, attol, aki megnyitotta a fajlvalasztot es meggondolta
    magat, es attol, aki valasztott valamit, de mi utasitottuk vissza.
    Harom teljesen kulonbozo baj, ugyanaz a nulla.

    A negy uj esemeny pontosan ezt a szakaszt bontja fel:

      upload_cta_clicked  ra kattintott a feltoltesre
      file_picker_opened  megnyilt a rendszer fajlvalasztoja
      file_chosen_raw     valasztott legalabb egy fajlt (meg feldolgozatlanul)
      file_accepted       a fajl atment a feldolgozason
    ────────────────────────────────────────────────────────────────
  */
  | 'upload_cta_clicked'
  | 'file_picker_opened'
  | 'file_chosen_raw'
  | 'file_accepted'
  /**
   * A „Nincs nalam a fajl" ut: a latogato sajat cimere kert emlekeztetot.
   *
   * Az `ok` prop mondja meg, sikerult-e - a hibas cim es a forgalomkorlat
   * ket kulonbozo baj, es csak igy lehet szetvalasztani oket a kilepestol.
   * MAGA A CIM sosem megy el (a `sanitise` amugy is kidobna).
   */
  | 'estimate_reminder_requested'
  /**
   * ELAKADAS: a „Tovább" tiltott volt, es a latogato latta, mi hianyzik.
   *
   * Ez valasztja szet azt, aki UNTA, attol, akit MEGALLITOTTUNK. Aki azert
   * megy el, mert nem erdekli, azon nem tudunk segiteni; aki azert, mert
   * nem erti, mit kerunk tole, azon igen.
   *
   * Propjai: `step` (melyik lepes) es `reason` (a felulet uzenete,
   * roviditve). Szemelyes adat nincs benne.
   */
  | 'step_blocked'
  | 'file_selected'
  /*
    A `file_accepted` ELODJE. Uj kod mar nem kuldi - a ket nev ugyanazt a
    pillanatot jelolne, es ketszer szamolna.

    A NEVET NEM IRJUK AT a regi sorokban (lasd a `STEP_IDS`-nel allo
    indoklast): a korabbi meres ezen a neven all az `analytics_events`
    tablaban. Az osszefuzest a `v_funnel_arbecsles` nezet vegzi el, ami
    mindkettot `file_accepted`-kent szamolja - igy az idosor folytonos
    marad anelkul, hogy barmit at kellene irni.
  */
  | 'file_validated'
  /**
   * Elutasitott fajl. MINDIG visz `reason` propot (hibakod) - enelkul
   * csak azt tudnank, hogy elbukott, azt nem, hogy miert.
   */
  | 'file_rejected'
  | 'step_viewed'
  | 'step_completed'
  | 'estimate_shown'
  | 'quote_submitted'
  | 'upload_started'
  | 'upload_completed'
  | 'upload_failed'
  | 'slice_queued'
  | 'slice_started'
  | 'slice_completed'
  | 'slice_failed'
  | 'quote_viewed'
  | 'quote_accepted'
  | 'payment_instructions_viewed'
  | 'payment_confirmed'
  | 'order_started'
  | 'order_completed'
  | 'express_selected'
  // ─────────── a fooldali feltolto es a ZIP ───────────
  | 'homepage_upload_started'
  | 'zip_selected'
  | 'zip_extracted'
  | 'zip_rejected'
  // ─────────── elonezet ───────────
  | 'preview_failed'
  // ─────────── atvetel ───────────
  | 'delivery_method_selected'
  | 'courier_selected'
  | 'pickup_map_opened'
  | 'pickup_point_selected'
  | 'pickup_map_failed'
  // ─────────── feldolgozas ───────────
  /*
    A VARAKOZAS HAROM SZAKASZA - KET KULON ESEMENY.

    A `slow_wait` (30 mp) meg csak hangnemet valt es marasztal, a
    `long_wait` (120 mp) mar felajanlja a bezarast es az e-mailes
    ertesitest. Azert kulon esemeny, mert a tolcserben mast merünk
    veluk: az elso azt, milyen gyakran lassu a feldolgozas, a masodik
    azt, hany latogatot engedtunk el.
  */
  | 'slow_wait_message_shown'
  | 'long_wait_message_shown'
  | 'forge_fallback_shown'
  | 'estimate_completed'
  | 'quote_submission_failed'
  // ─────────── hibahatar ───────────
  /*
    A VARAZSLO OSSZEOMLASA - az `ErrorBoundary` kuldi.

    Ez a nev korabban HIANYZOTT ebbol az uniobol, ezert a hivo helynek
    `string`-en at kellett szelesitenie a tipust: egy elgepelt esemenynev
    igy csendben atment volna a forditon.

    EZ AZ UNIO ONMAGABAN NEM ELEG. A szerveroldali `analytics_track`
    fuggveny SAJAT esemenynev-feherlistat tart, es az ismeretlen nevet
    CSENDBEN ELDOBJA - nem hibazik, nem naploz. Amig egy nev oda be nem
    kerul, az esemeny elindul a bongeszobol, de sehol nem tarolodik: a
    meresben NULLA latszik belole, barmennyi tortenik valojaban.

    A ket listat a `20260819170000_analytics_event_whitelist.sql` migracio
    hozza szinkronba: a szerveroldali feherlista ott az EGESZ unio. Amig ez
    a migracio nincs kiadva, az adott kornyezetben tovabbra is eldobas van.

    Uj esemeny felvetelekor MINDKET helyen fel kell venni - ide, es abba a
    listaba.
  */
  | 'estimate_wizard_crashed'
  // ─────────── kapcsolatfelvetel ───────────
  /*
    TELEFON- ES E-MAIL-KATTINTAS.

    A folyamat NEM csak a varazsloval er veget: aki bizonytalan, felhiv
    vagy ir. Eddig ez SEHOL nem latszott, tehat a tolcser vegen ulo
    lemorzsolodas egy resze valojaban megszerzett erdeklodo volt.

    Egyetlen helyrol jon (`contactClicks.ts`), esemenydelegalassal, a
    `tel:` es `mailto:` hivatkozasokra. Nem az egyes komponensekbol -
    igy egy kesobb hozzaadott kapcsolati link is meressel szuletik.

    A `kind` prop erteke `telefon` vagy `email`; MAGA a szam es a cim
    nem megy el sehova (a `sanitise` amugy is kiszurne).
  */
  | 'contact_clicked'

/**
 * A LEPESEK AZONOSITOI - A VARAZSLOBOL SZARMAZTATVA.
 *
 * A `step_viewed` / `step_completed` esemenyek EZEKET kuldik a `step`
 * propban (a hivo hely a `STEPS[step].id`-t adja at), es a lepesenkenti
 * lemorzsolodas erre az azonositora csoportositva jon ki - az ertekek az
 * `analytics_events.props` mezoben allnak.
 *
 * MA EGYETLEN KOD SEM OLVASSA EZT A LISTAT. A `v_funnel` nezet ESEMENYNEVRE
 * csoportosit, nem a `step` propra, es az `AdminPage` is azt jeleniti meg.
 * Ez a lista tehat a lepes-azonositok egyetlen dokumentalt igazsagforrasa:
 * ha keszul lepesenkenti nezet vagy BI-lekerdezes, EBBOL induljon ki.
 *
 * ────────────────────────────────────────────────────────────────────
 * MIERT SZARMAZTATOTT, ES NEM KEZZEL IRT LISTA
 *
 * Kezzel irva NEGY azonosito allt itt - `modellek`, `beallitasok`,
 * `atvetel`, `kapcsolat` -, mikozben a varazslo mar NYOLCAT kuldott: a
 * `beallitasok` lepes anyagra, szinre es minosegre bomlott, majd jott az
 * `extrak` es az `osszegzes` is. A `track` propjainak tipusa
 * `Record<string, ...>`, ezert a fordito egyetlen szot sem szolt: a lista
 * csendben elavult - barmely lepesenkenti kiertekeles OT azonositot nem
 * ismert volna fel, es egy olyat keresett, ami mar nem letezik.
 *
 * Ezert a lista mostantol a `STEPS`-bol szarmazik. Uj lepes felvetele
 * vagy sorrendcsere utan itt NINCS teendo - nem tud megint elcsuszni.
 *
 * Az import iranya (lib -> components) SZANDEKOS: a lepesek sorrendje a
 * varazslo dolga, a meres csak KOVETI. Korkoros import nem keletkezik, es
 * a meres nem huz be komponenskodot azokra az oldalakra sem, amelyek csak
 * `page_view`-t kuldenek: a `wizardTypes` minden importja `import type`,
 * ezert a lefordult modul fuggetlen.
 * ────────────────────────────────────────────────────────────────────
 *
 * ATNEVEZNI EZUTAN SEM SZABAD. Egy azonosito atirasa a lepesenkenti
 * kiertekeles IDOBELI folytonossagat tori el: a regi bejegyzesek a regi
 * neven maradnak az `analytics_events` tablaban - a `beallitasok` sorok ma
 * is ott vannak -, es a ket nev ket kulon lepesnek latszik.
 */
export type StepId = (typeof STEPS)[number]['id']
export const STEP_IDS: readonly StepId[] = STEPS.map((lepes) => lepes.id)

/**
 * A tarolt bejegyzes kulcsa. Beszedes nev: aki megnyitja a bongeszo
 * fejlesztoi eszkozeit, lassa, mi ez, es hogy nyugodtan torolheto.
 */
const STORAGE_KEY = 'voxora.meres'

/** Ennyi tetlenseg utan uj latogatas kezdodik. */
const IDLE_MS = 30 * 60 * 1000

/**
 * Ennel tovabb egy azonosito akkor sem el, ha folyamatos a hasznalat.
 *
 * A tetlensegi hatar onmagaban keves lenne: egy nyitva felejtett fül
 * naprol napra gorgetne tovabb ugyanazt az azonositot, es abbol
 * eszrevetlenul szemelykoveto azonosito lenne.
 */
const MAX_MS = 12 * 60 * 60 * 1000

/*
  A meresi RPC-hez nem toltjuk be a teljes Supabase klienskonyvtarat.
  Ez az egy vegpont egy szabvanyos, 1 kB koruli `fetch` keres: az anon
  kulcs publikus kliensbeallitas, a jogosultsagot tovabbra is az RPC es
  az adatbazis adja. Igy a fooldal nyitocsomagjabol kiesik az Auth,
  Realtime, Storage es PostgREST kliens teljes kodja.
*/
const SUPABASE_URL = (
  (import.meta.env as Record<string, string | undefined>).VITE_SUPABASE_URL ?? ''
).replace(/\/$/, '')
const SUPABASE_KEY = (
  (import.meta.env as Record<string, string | undefined>).VITE_SUPABASE_PUBLISHABLE_KEY ?? ''
).trim()

const PAGE_VIEW_DELAY_MS = 5000

/**
 * Az egysegteszt, a fejlesztoi szerver es a helyi production-preview nem
 * irhat az eles analitikai tablaba. A Meta-lekepezest ez nem kapcsolja ki:
 * annak kulon tesztjei vannak, csak a sajat Supabase RPC kapja ezt a kaput.
 */
function sajatMeresEngedelyezett(): boolean {
  const mode = (import.meta.env as Record<string, string | undefined>).MODE ?? ''
  if (mode === 'test' || mode === 'development') return false

  try {
    const host = location.hostname.toLowerCase()
    return host !== 'localhost' && host !== '127.0.0.1' && host !== '::1'
  } catch {
    return false
  }
}

interface StoredVisit {
  /** Veletlen, vissza nem fejtheto azonosito. */
  id: string
  /** Mikor kezdodott a latogatas (ezredmasodperc). */
  kezdet: number
  /** Mikor tortent az utolso esemeny. */
  utolso: number
}

/** Ha a tarolo nem elerheto (privat mod, kikapcsolt tarolas), ez marad. */
let memoryVisit: StoredVisit | null = null

function newId(): string {
  try {
    return crypto.randomUUID().replace(/-/g, '').slice(0, 24)
  } catch {
    // Regi bongeszo: gyengebb, de a merese ugyanolyan celra eleg.
    return `f${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`
  }
}

/** A tarolt bejegyzes beolvasasa. Barmilyen hiba eseten `null`. */
function readVisit(): StoredVisit | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null

    const parsed = JSON.parse(raw) as Partial<StoredVisit>
    if (
      typeof parsed?.id !== 'string' ||
      typeof parsed.kezdet !== 'number' ||
      typeof parsed.utolso !== 'number'
    ) {
      return null
    }
    return { id: parsed.id, kezdet: parsed.kezdet, utolso: parsed.utolso }
  } catch {
    /*
      Idekerulunk, ha a tarolas tiltott (privat mod, ceges hazirend), ha
      a bejegyzes serult, vagy ha valaki kezzel atirta. Egyik sem hiba:
      a meres visszaesik a memoriaban tartott azonositora, es az oldal
      valtozatlanul mukodik.
    */
    return null
  }
}

function writeVisit(visit: StoredVisit): void {
  memoryVisit = visit
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(visit))
  } catch {
    // Tele tarhely vagy tiltott tarolas - a memoriaban tartott ertek marad.
  }
}

/**
 * AZ AKTUALIS LATOGATAS AZONOSITOJA.
 *
 * Minden esemenynel fut, es ilyenkor elore is tolja a tetlensegi hatart:
 * amig a latogato dolgozik az oldalon, ugyanaz a latogatas tart.
 */
function sessionId(): string {
  const now = Date.now()
  const stored = readVisit() ?? memoryVisit

  const ervenyes =
    stored !== null && now - stored.utolso < IDLE_MS && now - stored.kezdet < MAX_MS

  /*
    A JOVOBELI IDOBELYEG IS ERVENYTELEN.

    Ha a gep oraja elore all, majd visszaall, egy "jovobol jott"
    bejegyzes maradhat, ami a kulonbseg-szamitas miatt orokre
    ervenyesnek latszana. Ezt inkabb eldobjuk.
  */
  const jovobeli = stored !== null && stored.utolso > now + IDLE_MS

  if (ervenyes && !jovobeli) {
    writeVisit({ ...stored, utolso: now })
    return stored.id
  }

  const friss: StoredVisit = { id: newId(), kezdet: now, utolso: now }
  writeVisit(friss)
  return friss.id
}

/**
 * A MERESI BEJEGYZES TORLESE.
 *
 * Az adatkezelesi tajekoztato ezt igeri: a latogato a bongeszo
 * tarhelyenek torlesevel megszakithatja az osszefuzest. Ez a fuggveny
 * ugyanazt teszi egy lepesben, es a legkozelebbi esemeny mar uj
 * azonositoval megy.
 */
/**
 * CSAK TESZTHEZ: az azonosito kiolvasasa esemenykuldes nelkul.
 *
 * A `track` halozati hivast indit, es az egysegtesztben nem az a
 * kerdes. Az elettartam-szabalyokat viszont pontosan ez a fuggveny
 * hordozza, ezert kulon elerhetove tesszuk.
 */
export function __sessionIdForTests(): string {
  return sessionId()
}

export function forgetVisit(): void {
  memoryVisit = null
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Ha a tarolas eleve nem elerheto, nincs is mit torolni.
  }
}

/** Bongeszo es eszkoz - CSAK kategoria szinten, ujjlenyomat nelkul. */
function environment(): { device: string; browser: string } {
  const ua = navigator.userAgent
  const device = /Mobi|Android|iPhone/i.test(ua)
    ? 'mobil'
    : /iPad|Tablet/i.test(ua)
      ? 'tablet'
      : 'asztali'

  const browser = /Edg\//.test(ua)
    ? 'Edge'
    : /OPR\//.test(ua)
      ? 'Opera'
      : /Chrome\//.test(ua)
        ? 'Chrome'
        : /Safari\//.test(ua)
          ? 'Safari'
          : /Firefox\//.test(ua)
            ? 'Firefox'
            : 'egyéb'

  return { device, browser }
}

/**
 * A KAMPANYCIMKEK - A MENTETT EREDETBOL, NEM A PILLANATNYI CIMSORBOL.
 *
 * ────────────────────────────────────────────────────────────────────
 * MIERT NEM ELEG A `location.search`
 *
 * Ez a fuggveny korabban KIZAROLAG az aktualis URL-t olvasta. A hirdetesbol
 * erkezo latogato viszont a `/arbecsles?utm_...&fbadid=...` cimre jon, ott
 * atlep a varazslo kovetkezo lepesere, es a query string ELTUNIK. Az elso
 * esemeny (`page_view`) meg vitte a cimkeket, a `file_accepted`, az
 * `estimate_shown` es a `quote_submitted` MAR NEM.
 *
 * A kovetkezmeny nem "kevesebb adat", hanem TORZ adat: a tolcser teteje
 * kreativra bontva latszott, az alja viszont cimke nelkuli sorokba esett -
 * vagyis pont az a kerdes valt megvalaszolhatatlanna, hogy MELYIK kreativ
 * hoz ajanlatkerest.
 *
 * Az `attribution.ts` a BEERKEZESKOR menti az eredetet (30 napig), tehat
 * onnan akarhany kattintassal kesobb is megvan. A pillanatnyi URL csak
 * TARTALEK: ha a tarolas nem elerheto (privat ablak), legalabb a belepo
 * oldal esemenyei cimkezve legyenek.
 *
 * A `landing_path` ugyanabbol a rekordbol jon. Nem ugyanaz, mint a
 * `location.pathname`: az utobbi a varazslo kozepen is `/arbecsles`, de
 * egy fooldalrol indulo latogatonal is azza valna - az eredeti belepo
 * oldal viszont `/` volt. A tolcsert a BELEPO oldalra kell szamolni.
 * ────────────────────────────────────────────────────────────────────
 */
function utm(): Record<string, string | null> {
  try {
    const mentett = attribucio()
    const p = new URLSearchParams(location.search)

    /* A mentett ertek nyer; ha nincs, az aktualis cimsor. */
    const cimke = (kulcs: 'utm_source' | 'utm_medium' | 'utm_campaign' | 'utm_content'): string | null =>
      mentett?.last[kulcs] ?? p.get(kulcs)

    return {
      utm_source: cimke('utm_source'),
      utm_medium: cimke('utm_medium'),
      utm_campaign: cimke('utm_campaign'),
      /*
        A KREATIV AZONOSITOJA. A kampanyban ez a `mem_lehajto`,
        `mem_anakin`, ... ertek - ezen a bontason mulik, hogy melyik
        hirdetest erdemes tovabb vinni.
      */
      utm_content: cimke('utm_content'),
      /*
        Melyik oldalra ERKEZETT. Query nelkul: az ott levő azonositok nem
        a meresre tartoznak.
      */
      landing_path: mentett?.landing_path ?? location.pathname,
      // CSAK a hoszt, nem a teljes hivatkozo URL: az ut tartalmazhat
      // olyan adatot, ami ránk nem tartozik.
      referrer_host: document.referrer ? new URL(document.referrer).hostname : null
    }
  } catch {
    return {}
  }
}

/**
 * Esemeny rogzitese. SOSEM dob, es sosem varakoztat.
 *
 * Ha az analitika elbukik, az a latogato szamara lathatatlan kell hogy
 * maradjon: egy meresi hiba nem allithatja meg a rendelest.
 */
/**
 * SZEMELYES ADATOT SOSEM ENGEDUNK KI.
 *
 * A vedelem harmas: (1) a hivo helyek csak kategoriakat kuldenek,
 * (2) ez a szuro kidobja a tiltott kulcsokat, (3) a szerveroldali
 * `analytics_track` fuggveny ujra szur. Egy elirt hivas sem tud
 * fajlnevet, e-mailt vagy csomagpont-cimet kiszivárogtatni.
 */
const FORBIDDEN_PROP = /file_?name|filename|e-?mail|phone|telefon|address|cim|city|varos|zip|iranyitoszam|lat|lon|coord|point_name|street|nev|name/i

function sanitise(
  props: Record<string, string | number | boolean | null>
): Record<string, string | number | boolean | null> {
  const clean: Record<string, string | number | boolean | null> = {}
  for (const [key, value] of Object.entries(props)) {
    if (FORBIDDEN_PROP.test(key)) continue
    // Hosszu szoveg is lehet szemelyes adat - a kategoriak rovidek.
    if (typeof value === 'string' && value.length > 64) continue
    clean[key] = value
  }
  return clean
}

/**
 * A MERESI ESEMENYEK META-MEGFELELOI.
 *
 * ────────────────────────────────────────────────────────────────────
 * MIERT ITT, ES NEM A HIVO HELYEKEN
 *
 * Kezenfekvo lenne minden `track(...)` melle odairni egy `fbq(...)`-t is.
 * Az viszont KET, egymastol fuggetlenul romlo listat csinalna: ez a fajl
 * mar egyszer megirta, mi tortenik ilyenkor - a szerveroldali
 * feherlista NEGY honapig allt egy regi allapotban, es a hianyzo
 * esemenyek meresben NULLAKENT latszottak, nem hibakent.
 *
 * Ezert a marketingmeres UGYANABBOL az egy hivasbol agazik le, es a
 * lekepezes EGY tablazatban al. Egy uj esemeny felvetele itt egy sor;
 * elfelejteni nem lehet, mert a hivo hely nem is tud a Metarol.
 *
 * ────────────────────────────────────────────────────────────────────
 * A `page_view` SZANDEKOSAN HIANYZIK INNEN
 *
 * Azt a `metaPixel.ts` kezeli (`pixelOldalmegtekintes`), mert ott van az
 * a szures, ami az indulaskori dupla `PageView`-t kizarja. Ha ide is
 * bekerulne, minden oldalbetoltes ketszer szamitana.
 * ────────────────────────────────────────────────────────────────────
 */
interface MetaLekepezes {
  /** A Meta szabvanyos esemenyneve. */
  nev: string
  /** Melyik prop hordozza a forintosszeget, ha van ilyen. */
  ertek?: string
}

const META_ESEMENYEK: Partial<Record<AnalyticsEvent, MetaLekepezes>> = {
  /** A kalkulator megnyitasa - itt kezdodik az erdeklodes. */
  calculator_opened: { nev: 'ViewContent' },
  /** Kesz az arbecsles: a latogato mar konkret osszeget lat. */
  estimate_shown: { nev: 'AddToCart', ertek: 'total' },
  /** Az ajanlatkeres elment. EZ a fo konverzio a kampanyban. */
  quote_submitted: { nev: 'Lead', ertek: 'total' },
  /** A vegleges ajanlat elfogadva - innen mar fizetes kovetkezik. */
  quote_accepted: { nev: 'InitiateCheckout', ertek: 'total' },
  /** A fizetes beerkezett. A hirdetes megterulese ezen a szamon mulik. */
  payment_confirmed: { nev: 'Purchase', ertek: 'total' },
  /** Telefon- vagy e-mail-kattintas. */
  contact_clicked: { nev: 'Contact' }
}

/** Az oldal egyetlen penzneme. Ertek melle a Meta mindig ker penznemet. */
const PENZNEM = 'HUF'

/**
 * Tovabbadas a pixelnek - MAR MEGSZURT propokkal.
 *
 * A `props` ide a `sanitise` UTAN erkezik, tehat fajlnev, e-mail es
 * telefonszam eleve nem lehet benne. Ez nem veletlen sorrend: a Metahoz
 * kimeno adatnak ugyanazon a szuron kell atmennie, mint a sajatunknak.
 */
function metaTovabbit(
  event: AnalyticsEvent,
  props: Record<string, string | number | boolean | null>
): void {
  const lekepezes = META_ESEMENYEK[event]
  if (!lekepezes) return

  const parameterek: Record<string, string | number | boolean> = {}

  if (lekepezes.ertek) {
    const osszeg = props[lekepezes.ertek]
    /*
      NULLA ES HIANYZO ERTEK NELKUL KULDUNK.

      Egy `value: 0` a Meta feluleten nem "ismeretlen", hanem NULLA
      forintos konverzio: belemegy a ROAS-atlagba, es lehuzza. Inkabb
      ertek nelkuli esemeny, mint hamis nulla.
    */
    if (typeof osszeg === 'number' && Number.isFinite(osszeg) && osszeg > 0) {
      parameterek.value = osszeg
      parameterek.currency = PENZNEM
    }
  }

  const darab = props.items
  if (typeof darab === 'number' && darab > 0) parameterek.num_items = darab

  pixelEsemeny(lekepezes.nev, parameterek)
}

export function track(
  event: AnalyticsEvent,
  props: Record<string, string | number | boolean | null> = {},
  quoteId?: string
): void {
  props = sanitise(props)

  metaTovabbit(event, props)

  const kuldes = (): void => {
    if (!sajatMeresEngedelyezett() || !SUPABASE_URL || !SUPABASE_KEY) return

    const payload = {
      session_id: sessionId(),
      event,
      quote_id: quoteId ?? null,
      props,
      ...environment(),
      ...utm()
    }

    void fetch(`${SUPABASE_URL}/rest/v1/rpc/analytics_track`, {
      method: 'POST',
      headers: {
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${SUPABASE_KEY}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ payload }),
      keepalive: true
    }).then(
      () => undefined,
      () => undefined
    )
  }

  /*
    A nyito `page_view` nem lehet a kritikus keresesi lanc resze. A
    felhasznaloi es konverzios esemenyek tovabbra is azonnal mennek; csak
    a passziv oldalmegtekintes var addig, amig a kezdeti render befejezodott.
  */
  if (event === 'page_view') window.setTimeout(kuldes, PAGE_VIEW_DELAY_MS)
  else kuldes()
}
